export default "__VITE_ASSET__003cf703__"